import * as type from "../types";
import { put } from "../../config/Requests";
import { openSnackbarDispatch } from './requestActions';

export const changeUserDialog = value => {
    return dispatch => {
        dispatch({
            type: type.SET_USER_DIALOG,
            value: value
        });
    };
};

export const changeUsername = value => {
    return (dispatch, getState) => {
        let token = getState().authReducer.token;
        let data = {
            token: token,
            operator_nazwa: value
        }
        put(
            dispatch,
            '/kalendarz/edycja_nazwa_operator.php',
            data,
            () => {
                dispatch({
                    type: type.SET_OPERATOR_NAME,
                    value: value
                });
                openSnackbarDispatch(dispatch, "Nazwa użytkownika została zmieniona");
            }
        );
    };
};

export const changePassword = values => {
    return (dispatch, getState) => {
        let token = getState().authReducer.token;
        let data = {
            token: token,
            stare_haslo: values.oldPassword,
            nowe_haslo: values.newPassword
        }
        put(
            dispatch,
            'kalendarz/edycja_hasla_operator.php',
            data,
            () => openSnackbarDispatch(dispatch, "Hasło zostało zmienione")
        );
    };
}